export default __webpack_public_path__ + "static/media/hometaste-order-tracking-background.1adc1cd5.png";